import { DcrType } from '@/core/graphql/generated/types';

import { ReviewRow } from '../ReviewRow/ReviewRow';

const OMITTED_KEYS = ['vid_V', 'key', '_internalId', '__typename'];

/* eslint-disable @typescript-eslint/no-explicit-any */
export const generateReviewEntityRows = (
	fieldKey: string,
	changes: any,
	oldItem: any,
	newItem: any,
	fieldTranslations: any,
	isIndividualCard: boolean,
	dcrType: DcrType
) => {
	const isNewItem = !oldItem;
	const dirtyKeys = Object.keys(changes);
	const hasIdChange = dirtyKeys.includes('id');

	// Note(Filip): Here we filter out keys that we don't want to show in the review rows
	const filteredKeys = dirtyKeys.filter(key => {
		if (key === '_deleted') return false;

		if (isIndividualCard) {
			if (key === 'name') return false;
			if (
				(fieldKey === 'licenses' && key === 'licenseNumber') ||
				key === 'licenseNumber_V'
			)
				return false;

			// affiliations/addresses details hiding
			if (fieldKey === 'parenthcos' && key === 'addresses') return false;
			if (fieldKey === 'addresses' && key === 'businessCda_V') return false;

			return !['id', ...OMITTED_KEYS].includes(key);
		}

		if (key === 'name' && hasIdChange) return false;

		return !OMITTED_KEYS.includes(key);
	});

	const rows = filteredKeys.map(key => {
		let oldVal = oldItem?.[key];
		let newVal = changes[key];

		if (!isIndividualCard && key === 'id') {
			oldVal = oldItem?.name || oldVal;
			if (newItem?.name) {
				newVal = newItem.name;
			}
		}

		// Skip empty fields for new items
		if (
			isNewItem &&
			(newVal === '' || newVal === null || newVal === undefined)
		) {
			return null;
		}

		const customLabel = key;

		return (
			<ReviewRow
				key={key}
				labelKey={customLabel}
				oldVal={oldVal}
				newVal={newVal}
				fieldTranslations={fieldTranslations}
				dcrType={dcrType}
			/>
		);
	});

	return rows.filter(Boolean);
};
